import React, { useMemo } from "react";
import classnames from "classnames";
import { Path, UseFormRegister, Control, Controller } from "react-hook-form";
import { FilterCondition } from "../../constants/Enums";
import { FormField, ICheckbox, ISelect } from "../../ui-kit";

import styles from "./FormInterval.module.scss";
import { FormFieldType } from "../FormField";

const CONDITIONS_OPTIONS = [
  { title: "=", id: FilterCondition.Equal },
  { title: ">", id: FilterCondition.Greater },
  { title: ">=", id: FilterCondition.GreaterOrEqual },
  { title: "<", id: FilterCondition.Less },
  { title: "<=", id: FilterCondition.LessOrEqual },
  { title: "< >", id: FilterCondition.Between },
];

interface IFormIntervalValue {
  conditionType: number;
  value: number;
  valueTo: number;
}

interface IRegisterOptions {
  [key: string]:
    | number
    | string
    | boolean
    | { [key: string]: number | string }
    | ((v: any) => void);
}

interface IFormIntervalProps<T> {
  className?: string;
  label?: string;
  name?: Path<T>;
  type?: FormFieldType;
  disabled?: boolean;
  control?: Control<T>;
  register?: UseFormRegister<T>;
  errors?: UseFormRegister<T>;
  registerOptions?: IRegisterOptions;
  currentValue?: IFormIntervalValue;
  isFocused?: boolean;
  required?: boolean;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onInput?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FormInterval = <T,>({
  className,
  name,
  register,
  control,
  currentValue,
  label,
  disabled,
  required,
  errors,
  type = "number",
}: IFormIntervalProps<T>) => {
  const isBetween = useMemo(() => {
    return currentValue.conditionType === FilterCondition.Between;
  }, [currentValue.conditionType]);

  const hasBorder = useMemo(() => {
    if (!isBetween) {
      return styles["FormIntervalSelect--has-radius"];
    }
    return "";
  }, [currentValue.conditionType]);

  const isReverse = useMemo(() => {
    if (!isBetween) {
      return styles["FormInterval--reverse"];
    }
    return "";
  }, [currentValue.conditionType]);

  return (
    <div className={classnames(styles.FormInterval, isReverse, className)}>
      <FormField
        register={register}
        name={`${name}.value`}
        type={type}
        label={label}
        disabled={disabled}
        currentValue={currentValue.value}
        isRequired={required ?? required}
        error={errors && errors?.[name]?.value?.message}
      />
      <Controller
        control={control}
        name={`${name}.conditionType`}
        render={({ field }) => (
          <ISelect
            field={field}
            optionsArr={CONDITIONS_OPTIONS}
            placeholder="Условие"
            disabled={disabled}
            className={classnames(styles.FormIntervalSelect, hasBorder)}
          />
        )}
      />
      {isBetween && (
        <FormField
          register={register}
          name={`${name}.valueTo`}
          type={type}
          label={label}
          disabled={disabled}
          currentValue={currentValue.valueTo}
          // error={errors && errors?.[`${name}.valueTo`]?.message}
        />
      )}
    </div>
  );
};
